import { getErrorByKey } from 'utils';
import styled from 'styled-components';
import { colors } from 'components/styles/_variables';

const StyledText = styled.p`
  color: ${colors.theme.danger} !important;
  font-size: 14px !important;
  margin: 12px 0 !important;
`;

const BaseErrors = ({ errors, errorKey = 'base', errorMessage }) => {
  if (errorMessage) {
    return <StyledText>{errorMessage}</StyledText>;
  }
  const baseErrors = getErrorByKey(errors, errorKey);
  return <>{baseErrors && <StyledText>{baseErrors}</StyledText>}</>;
};

export default BaseErrors;
